import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
// import GD from "../../../RestAPI/getData";
import SoaFMSubscriptionCheck from '../../../RestAPI/SoaFMSubscription';
import PartnerSoaFM_SubscriptionCheck from '../../../RestAPI/PartnerSubscription/SoaFMSubscription';
import language from '../../../../assets/languages/language';
import PaginationHelper from './pagination.js';
import { browserHistory } from 'react-router';
import ModalComponent from '../../../Common/Modal';
import AlertMessage from '../../../config/alertMessage';
import PDFModelComponent from '../../../Common/PDFModel';
// import { getDeviceDetails } from "../../../../common/deviceDetails";
import { getIpAddress } from '../../../../common/getIpAddress';
import { renderHTMLContent } from '../../../../common/function.js';
/* eslint-disable*/
class SOA_FM_Readings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      pdfAlert: false,
      MessageTitle: `${language.LC().MESSAGE}`,
      MessageContent: AlertMessage.messageContent_soa_fm,
      question: [],
      token: '',
      idname: '',
      chapterid: parseInt(this.props.params.id),
      // chapterName: this.props.params.name,
      ValidToken: false,
      chapter_id: '',
      no_result_display: '',
      subscriptionstatus: '',
      showFreePremium: true,
      selectedmenu: 'soa_fm',
      selectedPage: parseInt(this.props.params.page),
      totalCount: 0,
      limit: 10,
      skip: 0,
      offset: 0,
      display_loader: 'show_block',
      pdfLoading: true,
      pdfLoadingAnswer: true,
      PDFDownloadType: 'Question',
      PDFContentMessage: language.LC().PDFContentMessage,
      type: 'question',
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.pdfAlertModel = this.pdfAlertModel.bind(this);
  }

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  pdfAlertModel() {
    this.setState({
      pdfAlert: !this.state.pdfAlert,
    });
  }
  /*
  --------------------------------
    On Page Load,init this method
  --------------------------------
  */
  componentDidMount = async () => {
    window.scrollTo(0, 0);
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    (await storage_session)
      ? this.setState({
        storage_session: storage_session,
        idname: storage_session['idname'],
        token: storage_session['token'],
      })
      : null;
    (await this.state.idname) === '' && this.state.token === ''
      ? this.setState({ loggedIn: false })
      : this.setState({ loggedIn: true });

    if (localStorage.getItem('selectedmenu') === 'frm') {
      this.context.router.push({
        pathname: '/soa/probability/questionbank/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }
    if (this.props.params.page) {
      await this.setState(
        {
          selectedPage: parseInt(this.props.params.page),
          skip: this.state.limit * (parseInt(this.props.params.page), -1),
        },
        () => {
          this.GetSubscription();
        },
      );
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.params.page !== prevProps.params.page) {
      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
      await this.setState({ loader: true });
      if (this.props.params.page) {
        await this.setState(
          {
            selectedPage: parseInt(this.props.params.page),
            skip: this.state.limit * (parseInt(this.props.params.page), -1),
          },
          () => {
            this.GetSubscription();
          },
        );
      }
    }
  }

  //it is use to redirect page

  static contextTypes = {
    router: React.PropTypes.object,
  };

  GetSubscription = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium: true, subscriptionstatus: 'free' }, () => {
            this.GETQuestions('free');
          });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                var isInArray_varPDF = false;
                isInArray_var = await PartnerSoaFM_SubscriptionCheck.checkSoaFMSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this.setState(
                    {
                      subscriptionstatus: 'paid',
                    },
                    () => {
                      this.GETQuestions('paid');
                    },
                  );
                } else {
                  this.setState(
                    {
                      showFreePremium: true,
                      subscriptionstatus: 'free',
                    },
                    () => {
                      this.GETQuestions('free');
                    },
                  );
                }

                isInArray_varPDF = await PartnerSoaFM_SubscriptionCheck.checkSoaFM_PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.type,
                );
                if (isInArray_varPDF) {
                  this.setState({
                    showFreePremium: false,
                  });
                } else {
                  this.setState({
                    showFreePremium: true,
                  });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.setState({ showFreePremium: true, subscriptionstatus: 'free' }, () => {
            this.GETQuestions('free');
          });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                var isInArray_varPDF = false;
                isInArray_var = await SoaFMSubscriptionCheck.checkSoaFMSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this.setState(
                    {
                      subscriptionstatus: 'paid',
                    },
                    () => {
                      this.GETQuestions('paid');
                    },
                  );
                } else {
                  this.setState(
                    {
                      showFreePremium: true,
                      subscriptionstatus: 'free',
                    },
                    () => {
                      this.GETQuestions('free');
                    },
                  );
                }

                isInArray_varPDF = await SoaFMSubscriptionCheck.checkSoaFM_PDFSubscription(
                  selectedmen,
                  exam_data,
                  this.state.type,
                );
                // console.log("PSVDVDV", isInArray_varPDF);
                if (isInArray_varPDF) {
                  this.setState({
                    showFreePremium: false,
                  });
                } else {
                  this.setState({
                    showFreePremium: true,
                  });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  /*
  -------------------------------------------------------
        Function to go to questions
  -------------------------------------------------------
  */
  GETQuestions = async status => {
    this.setState({ display_loader: 'show_block' });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      chapter_id: this.state.chapterid,
      subscriptionstatus: status,
      page: parseInt(this.state.selectedPage),
    };
    await FD.callAPI(
      App_data.backend_api + '/soa_fm_question_bank/getQuestionsAll_With_Pagination',
      data,
    ).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          question: resp.questions,
          totalCount: resp.totalCount,
          chapterName: resp.chapter.chapter_name,
        });

        this.setState({ display_loader: 'hide_block' });
        if (!resp.question.length) {
          this.setState({
            no_result_display: 'No Saved Questions',
            display_loader: 'hide_block',
          });
        }
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  //Function to redirect page to question bank page
  _getChapters = e => {
    this.context.router.push({
      pathname: '/soa/financialmathematics/questionbank',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  _startQuestion = async (chapter, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      chapter_id: chapter.chapter_id,
      question_no: chapter.id,
      offset: 0,
      limit: 1,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    await FD.callAPI(
      App_data.backend_api + '/soa_fm_question_bank/getSelectedQuestions',
      data,
    ).then(resp => {
      if (resp.success) {
        if (resp.questions.length) {
          this.context.router.push({
            pathname:
              '/soa/financialmathematics/beginchapter/' +
              this.state.selectedPage +
              '/' +
              chapter.chapter_id +
              '/' +
              resp.questions[0].id,
            state: {
              token: this.state.token,
              idname: this.state.idname,
              chapter: chapter.id,
              chapterName: chapter.name,
              page: this.props.location.query.page,
              subscriptionstatus: this.state.subscriptionstatus,
            },
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  };

  handleSelected = async page => {
    await this.setState(
      {
        display_loader: 'show_block',
        selectedPage: page.currentPage,
        skip: this.state.limit * (page.currentPage - 1),
      },
      () => {
        browserHistory.push(
          `/soa/financialmathematics/readings/${this.state.chapterid}/${page.currentPage}`,
        );
      },
    );
  };

  /*
------------------------------
 Question PDF DOWNLOAD  via email
-------------------------------
*/
  getpdf = async e => {
    if (this.state.pdfLoading == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoadingAnswer == false) {
      alert('Please wait one process is in queue.');
      return;
    }

    if (this.state.showFreePremium) {
      this.toggleAlert();
    } else {
      this.setState({
        pdfLoading: false,
      });
      // const result = getDeviceDetails();
      var dataset = {
        token: this.state.token,
        idname: this.state.idname,
        chapterId: this.state.chapterid,
        city: this.state.user_city,
        country: this.state.user_country,
        state: this.state.user_state,
        continent: this.state.user_continent,
        ip: this.state.user_ip,
      };
      await FD.callAPI(
        App_data.backend_api + '/soa_fm_question_bank/Q-PdfDownloadViaEmail',
        dataset,
      ).then(response => {
        if (response.success) {
          this.setState({
            pdfLoading: true,
            PDFDownloadType: 'Question',
          });
          this.pdfAlertModel();
        } else if (!response.pdf) {
          this.setState({
            pdfLoading: true,
            PDFDownloadType: 'Question',
          });
          this.pdfAlertModel();
        }
      });
    }
  };

  /*
----------------------------------------------
  Question PDF DOWNLOAD and Answer via email
----------------------------------------------
*/
  getpdfAnswer = async e => {
    if (this.state.pdfLoadingAnswer == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoading == false) {
      alert('Please wait one process is in queue.');
      return;
    }

    if (this.state.showFreePremium) {
      this.toggleAlert();
    } else {
      this.setState({
        pdfLoadingAnswer: false,
      });
      // const result = getDeviceDetails();
      var dataset = {
        token: this.state.token,
        idname: this.state.idname,
        chapterId: this.state.chapterid,
        city: this.state.user_city,
        country: this.state.user_country,
        state: this.state.user_state,
        continent: this.state.user_continent,
        ip: this.state.user_ip,
      };
      await FD.callAPI(
        App_data.backend_api + '/soa_fm_question_bank/QA-PdfDownloadViaEmail',
        dataset,
      ).then(response => {
        if (response.success) {
          this.setState({
            pdfLoadingAnswer: true,
            PDFDownloadType: 'Question/Answer',
          });
          this.pdfAlertModel();
        } else if (!response.pdf) {
          this.setState({
            pdfLoadingAnswer: true,
            PDFDownloadType: 'Question/Answer',
          });
          this.pdfAlertModel();
        }
      });
    }
  };

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }
  render() {
    let question = this.state.question;
    let data = '';
    let selectedPage = this.state.selectedPage;
    let totalCount = this.state.totalCount;
    let limit = this.state.limit;

    if (this.state.question.length) {
      data = question.map((item, index) => (
        <tr key={index}>
          <td>{item.id}.</td>
          <td
            id={'questionNameId_' + index}
            contentEditable="false"
            className="view_question_height view_questionhtml hide-question"
          >
            {renderHTMLContent(
              item.question.substring(
                0,
                item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 70
              ) + '...'
            )}
          </td>

          <td id={'questionNameId_' + index.id}>
            <QuestionChecked
              question_id={item}
              token={this.state.token}
              idname={this.state.idname}
              answered_state={item.id}
            />
          </td>
          <td>
            <a href='javascript: void(0)' onClick={this._startQuestion.bind(this, item, index)}>
              {language.LC().VIEW}
            </a>
          </td>
        </tr>
      ));
    } else {
      data = (
        renderHTMLContent(this.state.no_result_display, "div", "horizontal_mid card-block text-center text_light", { contentEditable: "false" })
      );
    }

    /*This is  child component for checked Question is answered or not*/
    function QuestionChecked(props) {
      var data = {
        token: props.token,
        idname: props.idname,
        question_id: props.question_id,
      };

      //Api to check quiz answered of particular question
      FD.callAPI(App_data.backend_api + '/soa_fm_question_bank/checkAnswered', data).then(resp => {
        if (resp.success) {
          // console.log(resp.question_recived);
          if (resp.question_recived.right_answer === 1) {
            if (document.getElementById('user_question_status' + props.answered_state)) {
              document.getElementById('user_question_status' + props.answered_state).id =
                'quiz_answered_status';
              document.getElementById('answer_flag' + props.answered_state).innerHTML = `${language.LC().CORRECT_ANSWER
                }`;

              //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_green";
            }
          } else {
            if (document.getElementById('user_question_status' + props.answered_state)) {
              document.getElementById('user_question_status' + props.answered_state).id =
                'quiz_wrong_answered_status';
              //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_red";
              document.getElementById('answer_flag' + props.answered_state).innerHTML = `${language.LC().WRONG_ANSWER
                }`;
            }
          }
        } else {
          if (document.getElementById('user_question_status' + props.answered_state)) {
            document.getElementById('user_question_status' + props.answered_state).id =
              'quiz_notanswered_status';
            //document.getElementById('quiz_status_border_'+props.answered_state).id = "quiz_border_blue";
            document.getElementById('answer_flag' + props.answered_state).innerHTML = `${language.LC().NO_ANSWER
              }`;
          }
        }
        // this.setState({ display_loader: "hide_block" });
      });

      return (
        <div>
          <span className='margin_right_20' id={'user_question_status' + props.answered_state} />
          <span id={'answer_flag' + props.answered_state} />
        </div>
      );
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-md-8 margin_bottom_20'>
              <h1 className='section_head'>
                Chapter {this.state.chapterid}: {this.state.chapterName}
              </h1>
            </div>
            <div className='col-md-4 text-md-right margin_bottom_20 question-download-reading-page'>
              <div onClick={this.getpdf.bind(this)} className='status-download-btn margin_right_10'>
                <a className='btn btn-primary  pointer_class pull-right'>
                  {this.state.pdfLoading ? (
                    <i className='fa fa-download' aria-hidden='true' />
                  ) : (
                    <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                  )}
                  {this.state.showFreePremium ? (
                    <div className='premium-download'>{language.LC().PREMIUM}</div>
                  ) : null}
                  {this.state.pdfLoading ? language.LC().Download_Question : '  please wait...'}
                </a>
              </div>
              <div
                onClick={this.getpdfAnswer.bind(this)}
                className='status-download-btn margin_right_10'
              >
                <a className='btn btn-primary  pointer_class pull-right'>
                  {this.state.pdfLoadingAnswer ? (
                    <i className='fa fa-download' aria-hidden='true' />
                  ) : (
                    <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                  )}
                  {this.state.showFreePremium ? (
                    <div className='premium-download'>{language.LC().PREMIUM}</div>
                  ) : null}
                  {this.state.pdfLoadingAnswer
                    ? language.LC().Download_Question_Answer
                    : '  please wait...'}
                </a>
              </div>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getChapters}
              >
                {' '}
                {language.LC().CHANGE_CHAPTER}{' '}
              </button>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='card height_70vh'>
                <div className='card-header'>{/* {language.LC().CHAPTER_READINGS} */}</div>
                {/* {question != "" ? ( */}
                {/* <div className={"loader_box " + this.state.display_loader}> */}
                <div className='table_responsive_wrapper'>
                  <div className='table-responsive'>
                    <table className='table_white_bg table'>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='90'>#</th>
                          <th>{language.LC().QUESTIONS}</th>
                          <th>{language.LC().YOURS_ANSWER}</th>
                          <th>{language.LC().ACTION}</th>
                        </tr>
                      </thead>
                      <tbody>{data}</tbody>
                    </table>
                  </div>
                </div>
                {/* </div> */}
                {/* ) : null} */}
              </div>
              {totalCount > 0 ? (
                <PaginationHelper
                  totalRecords={totalCount}
                  onPageChanged={this.handleSelected}
                  currentPage={parseInt(selectedPage)}
                  pageLimit={limit}
                />
              ) : null}
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />

        <PDFModelComponent
          type={this.state.PDFDownloadType}
          pdfAlertModel={this.pdfAlertModel.bind(this)}
          pdfAlert={this.state.pdfAlert}
          PDFContentMessage={this.state.PDFContentMessage}
        />

        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

//  <script type="text/x-mathjax-config">
// window.MathJax.Hub.Config({
//   messageStyle: "none",
// tex2jax: { preview: "none" }
// });
{
  /* </script> */
}
export default SOA_FM_Readings;



// WEBPACK FOOTER //
// ./src/views/SOA/FinancialMathematics/Readings/Readings.js